var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import ReactTextMask from 'react-text-mask';
import TextField from '../../../uikit/inputs/TextField';
export function MaskedInput(props) {
    var mask = props.mask, keepCharPositions = props.keepCharPositions, placeholderChar = props.placeholderChar, _a = props.shouldShowGuide, shouldShowGuide = _a === void 0 ? true : _a, onChange = props.onChange, onBlur = props.onBlur, onFocus = props.onFocus, inputProps = __rest(props, ["mask", "keepCharPositions", "placeholderChar", "shouldShowGuide", "onChange", "onBlur", "onFocus"]);
    var commonEventProps = { onChange: onChange, onBlur: onBlur, onFocus: onFocus };
    return (React.createElement(ReactTextMask, __assign({ mask: mask, keepCharPositions: keepCharPositions, guide: shouldShowGuide }, (!!placeholderChar && { placeholderChar: placeholderChar }), commonEventProps, { render: function (inputRef, propsOfMaskedInput) {
            // @note: suppress warning, related to both value and defaultValue
            // https://github.com/text-mask/text-mask/issues/530
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            var defaultValue = propsOfMaskedInput.defaultValue, clearPropsOfMaskedInput = __rest(propsOfMaskedInput, ["defaultValue"]);
            return (React.createElement(TextField, __assign({ ref: inputRef }, commonEventProps, inputProps, clearPropsOfMaskedInput)));
        } })));
}
